
// Determine if user is new or returning web visitor based on GA cookies
function isReturningVisitor() {
  function hasCookie(name) {
    return document.cookie.split('; ').some(function(c){ return c.indexOf(name + '=') === 0; });
  }

  // check for GA cookies
  var hasGA =
      hasCookie('_ga') ||
      hasCookie('_gid') ||
      // any cookie that begins with _ga_ (GA4 container-specific)
      document.cookie.indexOf('_ga_') !== -1;

  var returning = hasGA;
  return returning;
}

// Determine if user is new or existing customer (shopify logged in)
function isShopifyLoggedIn() {
  return typeof Shopify !== 'undefined' && typeof Shopify.customer !== "undefined";
}
